import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const ContractSidebar = ({
  contracts,
  selectedContract,
  onContractSelect,
  activeCategory,
  onCategoryChange,
  searchQuery,
  onSearchChange,
  stats
}) => {
  const categories = [
    { id: 'all', label: 'جميع العقود', icon: 'FileText', count: stats?.total, color: '#3B82F6' },
    { id: 'pending', label: 'قيد الانتظار', icon: 'Clock', count: stats?.pending, color: '#F59E0B' },
    { id: 'signed', label: 'موقّعة', icon: 'CheckCircle', count: stats?.signed, color: '#10B981' },
    { id: 'expired', label: 'منتهية', icon: 'XCircle', count: stats?.expired, color: '#EF4444' }
  ];

  const getStatusColor = (status) => {
    const colors = {
      pending: '#F59E0B',
      signed: '#10B981',
      rejected: '#EF4444',
      expired: '#6B7280'
    };
    return colors?.[status] || '#6B7280';
  };

  const getStatusLabel = (status) => {
    const labels = {
      pending: 'قيد الانتظار',
      signed: 'موقّع',
      rejected: 'مرفوض',
      expired: 'منتهي'
    };
    return labels?.[status] || status;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString)?.toLocaleDateString('ar-SA', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="w-1/4 bg-gray-800 border-l border-gray-700 flex flex-col">
      {/* Search */}
      <div className="p-4 border-b border-gray-700">
        <div className="relative">
          <Input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            placeholder="البحث في العقود..."
            className="w-full pr-10 bg-gray-900/50 border-gray-600 text-white placeholder-gray-500"
          />
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            <Icon name="Search" size={18} color="#9CA3AF" />
          </div>
        </div>
      </div>
      {/* Categories */}
      <div className="p-4 border-b border-gray-700">
        <h3 className="text-sm font-semibold text-gray-400 mb-3">التصنيفات</h3>
        <div className="space-y-2">
          {categories?.map(category => (
            <button
              key={category?.id}
              onClick={() => onCategoryChange(category?.id)}
              className={`w-full flex items-center justify-between p-3 rounded-lg transition-all ${
                activeCategory === category?.id
                  ? 'bg-gray-700 border border-gray-600' :'hover:bg-gray-700/50'
              }`}
            >
              <div className="flex items-center gap-3">
                <Icon name={category?.icon} size={18} color={category?.color} />
                <span className="text-sm font-medium text-white">{category?.label}</span>
              </div>
              <span className="text-xs font-semibold text-gray-400 bg-gray-900/50 px-2 py-1 rounded">
                {category?.count}
              </span>
            </button>
          ))}
        </div>
      </div>
      {/* Contract List */}
      <div className="flex-1 overflow-y-auto">
        {contracts?.length === 0 ? (
          <div className="p-8 text-center">
            <Icon name="FileX" size={48} color="#6B7280" className="mx-auto mb-3" />
            <p className="text-gray-500 text-sm">لا توجد عقود</p>
          </div>
        ) : (
          <div className="p-4 space-y-3">
            {contracts?.map(contract => (
              <button
                key={contract?.id}
                onClick={() => onContractSelect(contract)}
                className={`w-full text-right p-4 rounded-lg border transition-all ${
                  selectedContract?.id === contract?.id
                    ? 'bg-gray-700 border-amber-500/50 shadow-lg'
                    : 'bg-gray-800/50 border-gray-700 hover:bg-gray-700/50'
                }`}
              >
                {/* Contract Number */}
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm font-bold text-white">
                    {contract?.contractNumber || 'عقد جديد'}
                  </span>
                  <span
                    className="text-xs font-semibold px-2 py-1 rounded"
                    style={{
                      backgroundColor: `${getStatusColor(contract?.signatureStatus)}20`,
                      color: getStatusColor(contract?.signatureStatus)
                    }}
                  >
                    {getStatusLabel(contract?.signatureStatus)}
                  </span>
                </div>

                {/* Property Info */}
                <p className="text-xs text-gray-400 mb-2 line-clamp-1">
                  {contract?.property?.title || 'عقار غير محدد'}
                </p>

                {/* Contract Type */}
                <div className="flex items-center gap-2 mb-2">
                  <Icon name="FileText" size={14} color="#9CA3AF" />
                  <span className="text-xs text-gray-500">{contract?.contractType || 'نوع العقد'}</span>
                </div>

                {/* Due Date */}
                {contract?.dueDate && contract?.signatureStatus === 'pending' && (
                  <div className="flex items-center gap-2 mt-2 pt-2 border-t border-gray-700">
                    <Icon name="Calendar" size={14} color="#F59E0B" />
                    <span className="text-xs text-amber-500">
                      مطلوب التوقيع قبل: {formatDate(contract?.dueDate)}
                    </span>
                  </div>
                )}

                {/* Progress Indicator */}
                {contract?.signatureStatus === 'pending' && (
                  <div className="mt-3">
                    <div className="w-full h-1 bg-gray-700 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-amber-500 rounded-full"
                        style={{ width: '50%' }}
                      ></div>
                    </div>
                  </div>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContractSidebar;